import axios from 'axios';

const teamApi = {
  async getTeams() {
    return await axios({
      url: '/api/tenant/team',
    }).then(r => r.data);
  },
  async getTeamsLite() {
    return await axios({
      url: '/api/tenant/team/lite',
    }).then(r => r.data);
  },
  async getTeam(key) {
    return await axios({
      url: `/api/tenant/team/${key}`,
    }).then(r => r.data);
  },
  async createTeam(team) {
    return await axios({
      url: '/api/tenant/team',
      method: 'POST',
      data: team,
    }).then(r => r.data);

  },
  async updateTeam(key, /* Team */ data) {
    return await axios({
      url: `/api/tenant/team/${key}`,
      method: 'PUT',
      data,
    }).then(r => r.data);
  },
  async deleteTeam(key) {
    return await axios({
      url: `/api/tenant/team/${key}`,
      method: 'DELETE',
    }).then(r => r.data);

  }
};
export default teamApi;
